module.exports = __webpack_public_path__ + "../resources/img/ic_scrolltop_focus.5d5a9427.svg";